import { render, staticRenderFns } from "./TemperatureViolationHistoryReportCard.vue?vue&type=template&id=00c897fc&scoped=true&"
import script from "./TemperatureViolationHistoryReportCard.vue?vue&type=script&lang=js&"
export * from "./TemperatureViolationHistoryReportCard.vue?vue&type=script&lang=js&"
import style0 from "./TemperatureViolationHistoryReportCard.vue?vue&type=style&index=0&id=00c897fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c897fc",
  null
  
)

export default component.exports